import React from 'react';
import '../../assets/css/PrintReserveInfoComponent.css';

export const PrintReservesTable = ({ 
    reserves = [], 
    currentPage = 1, 
    pageSize = 15,
    searchCriteria = {} 
}) => {
    
    if (!reserves || reserves.length === 0) {
        return (
            <div className="reserve-info-container only-print">
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <h2>گزارش رزروها</h2>
                    <p>هیچ داده‌ای برای نمایش وجود ندارد</p>
                </div>
            </div>
        );
    }

    const getRowNumber = (index) => {
        return (currentPage - 1) * pageSize + index + 1;
    };

    return (
        <div className="reserve-info-container only-print">
            {/* هدر گزارش */}
            <div style={{ 
                textAlign: 'center', 
                marginBottom: '15px',
                paddingBottom: '10px',
                borderBottom: '1px solid #333'
            }}>
                <h1 style={{ 
                    margin: '0 0 8px 0', 
                    fontSize: '20px',
                    fontWeight: 'bold'
                }}>
                    گزارش رزروها
                </h1>
                <div style={{ 
                    fontSize: '13px', 
                    color: '#555'
                }}>
                    <span style={{ margin: '0 15px' }}>
                        <strong>تاریخ چاپ:</strong> {new Date().toLocaleDateString('fa-IR')}
                    </span>
                    <span style={{ margin: '0 15px' }}>
                        <strong>تعداد:</strong> {reserves.length} رزرو
                    </span>
                    {currentPage > 1 && (
                        <span style={{ margin: '0 15px' }}>
                            <strong>صفحه:</strong> {currentPage}
                        </span>
                    )}
                </div>
            </div>

            {/* اطلاعات جستجو */}
            {Object.keys(searchCriteria).length > 0 && (
                <div style={{ 
                    marginBottom: '10px',
                    padding: '8px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '11px',
                    textAlign: 'center'
                }}>
                    <strong>شرایط جستجو:</strong>
                    {searchCriteria.trackingCode && ` کد: ${searchCriteria.trackingCode}`}
                    {searchCriteria.fullName && ` | نام: ${searchCriteria.fullName}`}
                    {searchCriteria.nationalCode && ` | کدملی: ${searchCriteria.nationalCode}`}
                </div>
            )}

            {/* جدول رزروها */}
            <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '11px',
                marginBottom: '15px'
            }}>
                <thead>
                    <tr style={{ 
                        backgroundColor: '#f0f0f0',
                        border: '1px solid #999'
                    }}>
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'center',
                            width: '40px',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>ردیف</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'right',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>مکان</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'right',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>نام و نام خانوادگی</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'center',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>تاریخ ورود</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'center',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>تاریخ خروج</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'center',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>تعداد افراد</th>
                        
                        <th style={{ 
                            padding: '8px 5px', 
                            textAlign: 'center',
                            border: '1px solid #999',
                            fontWeight: 'bold'
                        }}>کد پذیرش</th>
                    </tr>
                </thead>
                <tbody>
                    {reserves.map((record, index) => (
                        <tr key={record.id || index}>
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'center',
                                border: '1px solid #ddd'
                            }}>{getRowNumber(index)}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'right',
                                border: '1px solid #ddd'
                            }}>{record.objectInstance?.title || 'نامشخص'}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'right',
                                border: '1px solid #ddd'
                            }}>{record.fullName || '-'}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'center',
                                border: '1px solid #ddd'
                            }}>{record.from_Shamsi || '-'}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'center',
                                border: '1px solid #ddd'
                            }}>{record.to_Shamsi || '-'}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'center',
                                border: '1px solid #ddd'
                            }}>{record.reserve_Users?.length || 0}</td>
                            
                            <td style={{ 
                                padding: '6px 4px', 
                                textAlign: 'center',
                                border: '1px solid #ddd',
                                fontFamily: 'monospace'
                            }}>{record.trackingCode || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* جمع کل */}
            <div style={{ 
                marginTop: '15px',
                padding: '10px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #ddd',
                borderRadius: '4px',
                textAlign: 'center',
                fontSize: '12px'
            }}>
                <strong>
                    جمع کل: {reserves.length} رزرو | 
                    مجموع نفرات: {reserves.reduce((sum, record) => sum + (record?.reserve_Users?.length || 0), 0)} نفر
                </strong>
            </div>

            {/* فوتر */}
            <div style={{ 
                marginTop: '20px',
                paddingTop: '10px',
                borderTop: '1px solid #ddd',
                textAlign: 'center',
                fontSize: '10px',
                color: '#666',
                position: 'static' /* تغییر از absolute به static */
            }}>
                <div>سیستم مدیریت رزرو - چاپ شده در {new Date().toLocaleString('fa-IR')}</div>
            </div>
        </div>
    );
};